import { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";

export type AnnouncementType = "info" | "success" | "warning" | "urgent";

export interface Announcement {
  message: string;
  isEnabled: boolean;
  type: AnnouncementType;
  linkUrl: string;
  linkText: string;
  startsAt: string | null;
  endsAt: string | null;
  dismissible: boolean;
  updatedAt: string;
}

interface AnnouncementState {
  announcement: Announcement | null;
  isActive: boolean;
  loading: boolean;
}

export function useAnnouncement(): AnnouncementState {
  const [announcement, setAnnouncement] = useState<Announcement | null>(null);
  const [isActive, setIsActive] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/announcement`);
        const data = await response.json();
        setAnnouncement(data.announcement || null);
        setIsActive(!!data.isActive);
      } catch (error) {
        console.error("Error fetching announcement:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncement();
  }, []);

  return { announcement, isActive, loading };
}
